import { useTranslate } from "@refinedev/core";
import styled from "styled-components";
import { useAnalytics } from "hooks/useAnalytics";
import { AnalyticsEvents } from "types/analytics";
import { CHROME_EXTENSION_URL } from "../constants";
import chromeIllustration from "../../../../assets/img-chrome-Illustration.png";
import { radius } from "@libertify/ui";

export const ChromeExtensionCard = () => {
  const t = useTranslate();
  const { trackEvent } = useAnalytics();

  const handleClick = () => {
    trackEvent(AnalyticsEvents.ChromeExtensionClick, { page: "home" });
    window.open(CHROME_EXTENSION_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <Card onClick={handleClick}>
      <Badge>{t("pages.home.index.new").toUpperCase()}</Badge>
      <Title>{t("pages.home.index.chromeExtension")}</Title>
      <Subtitle>{t("pages.home.index.chromeExtensionDesc")}</Subtitle>
      <Image src={chromeIllustration} alt="" />
    </Card>
  );
};

const Card = styled.button`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px;
  border-radius: ${radius.box}px;
  width: 383px;
  flex-shrink: 0;
  height: 228px;

  @media (width <= 768px) {
    width: 100%;
    max-width: 345px;
    height: 205px;
    padding: 20px;
  }
  background-color: #ecfffe;
  border: 1.5px solid ${({ theme }) => theme.colorBorderSecondary};
  text-align: left;
  font-family: "Inter", sans-serif;
  transition: box-shadow 0.2s;
  cursor: pointer;
  overflow: hidden;

  &:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  }
`;

const Badge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  background-color: #090e19;
  color: #fff;
  font-family: "Inter", sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  width: fit-content;
  z-index: 1;
`;

const Title = styled.div`
  font-family: "Inter", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -0.8px;
  color: #090e19;
  margin-top: 24px;
  max-width: 50%;
  z-index: 1;
`;

const Subtitle = styled.div`
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 135%;
  letter-spacing: -0.3px;
  color: #090e19;
  margin-top: 24px;
  max-width: 50%;
  z-index: 1;
`;

const Image = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  height: 75%;
  width: auto;
  object-fit: contain;
  pointer-events: none;
`;
